//==========import components===============
import OurPartner from 'components/common/OurPartner';
import AboutEvent from 'components/common/AboutEvent';
import HomeLayout from 'layouts/HomeLayout';
import HomeServices from 'components/home/HomeServices';
import ClientsReviewCarousel from 'components/home/ClientsReviewCarousel';
import ServicesCarousel from 'components/home/ServicesCarousel';
//==========import helperData===============
import {
  partnerData,
  serviceCardData,
  homeAboutEventObj,
} from 'helpers/commonHelper';

const Home = () => {
  const titleDetail = {
    upperTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
    middleTitle: 'dE EVENTE PARTNERS',
    lowerTitle: '',
  };
  return (
    <div className='homePage DBlock relative'>
      <AboutEvent data={homeAboutEventObj} />
      <ServicesCarousel />
      <HomeServices data={serviceCardData} />
      <ClientsReviewCarousel />
      <OurPartner data={partnerData} titleDetail={titleDetail} />
    </div>
  );
};

export default HomeLayout(Home);
